import Vue from 'vue';
//import VueI18n from 'vue-i18n';
import App from './App.vue';
import router from './router';
import i18n from './i18n';

Vue.config.productionTip = false;
console.log(i18n);
new Vue({
	router,
	i18n,
	render: h => h(App)
}).$mount('#app');
